module.exports = __webpack_public_path__ + "static/media/kenku-head.3292e596.svg";